import currentStatusHttp from './currentStatusHttp';

const getCurrentStatus = (context, globalTags, groupTags) => {
  return new Promise((resolve, reject) => {
    currentStatusHttp.getCurrentStatus(context, globalTags, groupTags)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

export default {
  getCurrentStatus
};



// WEBPACK FOOTER //
// ./src/api/currentStatus/index.js